var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__group",class:{
			'form__group--is-focus': _vm.focus,
			'form__group--is-valid': _vm.localValue.length,
			'form__group--is-invalid': _vm.error,
		}},[_c('div',{staticClass:"form__wrap"},[_c('date-picker',{attrs:{"lang":_vm.lang,"format":_vm.format},on:{"open":_vm.handlerFocus,"close":_vm.hanlderBlur,"input":_vm.handlerInput},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}}),_c('span',{staticClass:"form__label"},[_vm._v(_vm._s(_vm.label))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }